import { render } from "./_payment.vue?vue&type=template&id=a97b4d44&scoped=true"
import script from "./_payment.vue?vue&type=script&lang=js"
export * from "./_payment.vue?vue&type=script&lang=js"

import "./_payment.vue?vue&type=style&index=0&id=a97b4d44&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97b4d44"]])

export default __exports__